import { Routes } from '@angular/router';
import { DictationPage } from './dictation-page';
import { DictationPhysicalPage } from './dictation-physical-page/dictation-physical-page';

export const mechanicDictationRoutes: Routes = [
  {
    path: '',
    component: DictationPage,
  },
  {
    path: 'physical',
    component: DictationPhysicalPage,
  },
];
